import React, { Fragment } from "react";
import Img from "gatsby-image";
import Zoom from "react-medium-image-zoom";

const ImageGallery = ({ items, caption }) => {
  items = items.map((item, index) => {
    return { ...item, row: Math.ceil((index + 1) / 3) - 1 };
  });

  const rows = [];
  const totalNumberOfImages = items.length;

  let maxImagesInRow = function (idx, totalNumberOfImages) {
    return (
      totalNumberOfImages > 1 &&
      totalNumberOfImages % 3 === 1 &&
      idx === totalNumberOfImages - 2
    );
  };

  items.forEach((item, idx) => {
    let row = item.row;
    if (maxImagesInRow(idx, totalNumberOfImages)) {
      row = row + 1;
    }
    // if (imageRows[row]) {
    //   imageRows[row].push(item);
    // } else {
    //   imageRows[row] = [];
    //   imageRows[row].push(item);
    // }
    if (!rows[row]) {
      rows[row] = [];
    }

    rows[row].push(item);
  });

  return (
    <figure className="image-gallery">
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {rows.map((row, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                flexWrap: "wrap",
                marginTop: index > 0 ? "10px" : 0,
                width: "100%",
              }}
            >
              {row.map((image, index) => {
                return (
                  <Fragment key={index}>
                    {image.fluidResult && (
                      <Zoom
                        wrapStyle={{
                          // width: "100%",
                          flex: `${
                            image.naturalWidth / image.naturalHeight
                          } 1 0`,
                        }}
                      >
                        <Img
                          fluid={image.fluidResult}
                          style={{
                            // flex: `${
                            //   image.naturalWidth / image.naturalHeight
                            // } 1 0`,
                            width: "100%",
                            height: "100%",
                            marginLeft: index !== 0 ? "10px" : 0,
                            marginTop: 0,
                          }}
                        ></Img>
                      </Zoom>
                    )}
                    {!image.fluidResult && (
                      <div
                        key={index}
                        style={{
                          flex: `${
                            image.naturalWidth / image.naturalHeight
                          } 1 0`,
                          marginLeft: index !== 0 ? "10px" : 0,
                        }}
                      >
                        <img
                          height={image.naturalHeight}
                          width={image.naturalWidth}
                          style={{ height: "100%", width: "100%" }}
                          src={image.src}
                        />
                      </div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          );
        })}
      </div>
      {caption && <figcaption dangerouslySetInnerHTML={{__html: caption}}></figcaption>}
    </figure>
  );
};

export default ImageGallery;
